import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
import { INote } from '../interface/notes';

interface IFetchNotesById {
  id?: string;
  relations?: string[];
  fields?: string[];
  sortBy?: string[];
}
export const useFetchNotesById = (params: IFetchNotesById) => {
  const { id, ...queryParams } = params;
  const queryString = Object.keys(queryParams)?.length
    ? toQueryString(queryParams as QueryParamObject)
    : null;
  const transactionUrl = `${API_URLS.NOTES_DETAILS}${id}`;
  const url = queryString ? `${transactionUrl}?${queryString}` : transactionUrl;
  const query = useQuery<INote, Error>({
    queryKey: ['notes-details', id],
    queryFn: async () => {
      const response = await get(url);
      return response;
    },
    enabled: !!id,
  });

  return query;
};
